import React, { useState, useEffect } from "react";
import { Loader2, Ticket, CheckCircle2, Info } from "lucide-react";

const TIKKIE_LINK = "https://tikkie.me/pay/dp3fqchnu0h6mo5ki8jv"; 

export default function GetCard() {
  const [paymentStatus, setPaymentStatus] = useState("idle"); 
  const [promoCode, setPromoCode] = useState("");
  const [discountApplied, setDiscountApplied] = useState(false);
  const [finalPrice, setFinalPrice] = useState(5);

  useEffect(() => {
    const navbar = document.querySelector('nav') || document.querySelector('.navbar');
    if (!navbar) return;

    if (paymentStatus !== "idle") {
      navbar.style.display = 'none'; 
    } else {
      navbar.style.display = 'flex'; 
    }

    return () => {
      if (navbar) navbar.style.display = 'flex';
    };
  }, [paymentStatus]);

  const applyDiscount = () => {
    const code = promoCode.toUpperCase().trim();
    const associationCodes = ["SDGAMBASSADOR","CEMS","PPI3","EPAR3","NSA3","EHCO3","PISE26"];
    
    if (associationCodes.includes(code)) {
      setFinalPrice(3); 
      setDiscountApplied(true);
    } else if (code === "ALEXTHEGOAT") {
      setFinalPrice(1); 
      setDiscountApplied(true);
    } else {
      setPromoCode("Invalid Code");
      setTimeout(() => setPromoCode(""), 2000);
    }
  };

  const startPayment = () => {
    setPaymentStatus("showing_instructions");
  };

  const confirmAndGoToTikkie = () => {
    window.open(`${TIKKIE_LINK}`, "_blank");
    setPaymentStatus("pending");
  };

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#FFFFFF",
      fontFamily: "'Inter', sans-serif",
      padding: "2rem 1.5rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: "#2D302D"
    },
    header: {
        marginBottom: "1rem", 
        textAlign: "center",
        maxWidth: "400px"
    },
    gradientHeadline: {
        fontSize: "2.2rem",
        fontWeight: "900",
        lineHeight: "1.2",
        background: "linear-gradient(90deg, #12873B 0%, #2D302D 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "block"
    },
    cardImage: {
      width: "100%",
      maxWidth: "360px",
      borderRadius: "24px",
      boxShadow: "0 20px 40px rgba(18, 135, 59, 0.15)",
      marginBottom: "2rem" 
    },
    mainCard: {
        width: "100%",
        maxWidth: "420px",
        backgroundColor: "#FBFDFB",
        borderRadius: "32px",
        padding: "2rem",
        border: "1px solid #E9F2EB",
        position: "relative"
    },
    priceDisplay: {
        display: "flex",
        alignItems: "baseline",
        gap: "4px",
        marginBottom: "1.5rem"
    },
    feature: {
        display: "flex",
        gap: "12px",
        marginBottom: "1rem",
        alignItems: "center",
        fontSize: "0.95rem",
        color: "#475569"
    },
    promoWrapper: {
        display: "flex",
        background: "#F1F5F1",
        borderRadius: "16px",
        padding: "4px",
        marginTop: "1.5rem"
    },
    input: {
        flex: 1,
        background: "transparent",
        border: "none",
        padding: "10px 15px",
        outline: "none",
        fontSize: "0.9rem"
    },
    payBtn: {
        width: "100%",
        maxWidth: "420px",
        background: "linear-gradient(90deg, #12873B 0%, #2D302D 100%)",
        color: "white",
        padding: "1.2rem",
        borderRadius: "20px",
        border: "none",
        fontWeight: "900",
        fontSize: "1.1rem",
        marginTop: "2rem",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        boxShadow: "0 10px 25px rgba(18, 135, 59, 0.25)",
        textDecoration: "none"
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.7)",
        backdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        zIndex: 2000
    },
    instructionBox: {
        backgroundColor: "white",
        borderRadius: "32px",
        padding: "2.5rem 2rem",
        maxWidth: "400px",
        width: "100%",
        textAlign: "center",
        position: "relative"
    }
  };

  return (
    <div style={styles.container}>
      
      <div style={styles.header}>
        <h1 style={styles.gradientHeadline}>
            Get Your Card Now!
        </h1>
        <p style={{ color: "#64748B", marginTop: "12px", fontWeight: "500" }}>
            5€ today, all year discounts at your favorite local spots.
        </p>
      </div>

      <img 
        src="https://paoletexuwmeuatvbkvf.supabase.co/storage/v1/object/public/backgrounds/HummingImage.png" 
        alt="Humming Member Card" 
        style={styles.cardImage}
      />

      <div style={styles.mainCard}>
        <div style={styles.priceDisplay}>
            {discountApplied && <span style={{ textDecoration: 'line-through', color: '#CBD5E1', fontSize: '1.2rem' }}>€5</span>}
            <span style={{ fontSize: "3rem", fontWeight: "900" }}>€{finalPrice}</span>
            <span style={{ color: "#94A3B8", fontWeight: "600" }}>/year</span>
        </div>

        <div style={styles.feature}>
            <CheckCircle2 color="#12873B" size={20} />
            <span>Exclusive deals at <b>15+ local partners</b></span>
        </div>
        <div style={styles.feature}>
            <CheckCircle2 color="#12873B" size={20} />
            <span>Get rewarded for your sustainable actions & responsible consumption</span>
        </div>
        <div style={styles.feature}>
            <CheckCircle2 color="#12873B" size={20} />
            <span><b>Digital & Physical</b> membership card</span>
        </div>

        <div style={styles.promoWrapper}>
            <input 
                style={styles.input} 
                placeholder="Discount Code" 
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
            />
            <button 
                onClick={applyDiscount}
                type="button"
                style={{ background: '#2D302D', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '12px', cursor: 'pointer' }}
            >
                <Ticket size={18} />
            </button>
        </div>
      </div>

      <button style={styles.payBtn} type="button" onClick={startPayment}>
        <CreditCardIcon size={22} />
        Get Your Card Now
      </button>

      {/* IN-APP MODAL */}
      {paymentStatus === "showing_instructions" && (
        <div style={styles.modalOverlay}>
            <div style={styles.instructionBox}>
                <div style={{ background: '#F1FBF4', width: '60px', height: '60px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
                    <div style={{ color: "#12873B" }}><Info size={30} /></div>
                </div>
                <h2 style={{ fontWeight: "900", marginBottom: "1rem" }}>Almost there!</h2>
                <p style={{ color: "#64748B", lineHeight: "1.6", fontSize: "0.95rem" }}>
                    On the next screen, pay <b>€{finalPrice}</b> via Tikkie.
                    <br/><br/>
                    <span style={{ color: "#12873B", fontWeight: "700" }}>IMPORTANT:</span> You <b>must</b> include your account email in the Tikkie note so we can activate your account!
                </p>
                
                <button 
                    onClick={confirmAndGoToTikkie}
                    type="button"
                    style={{ ...styles.payBtn, width: '100%', marginTop: '1.5rem' }}
                >
                    Understood, Let's Pay
                </button>
                <button 
                    onClick={() => setPaymentStatus('idle')}
                    type="button"
                    style={{ background: 'none', border: 'none', marginTop: '1rem', color: '#94A3B8', cursor: 'pointer' }}
                >
                    Cancel
                </button>
            </div>
        </div>
      )}

      {/* PENDING STATE */}
      {paymentStatus === "pending" && (
        <div style={styles.modalOverlay}>
            <div style={styles.instructionBox}>
                <Loader2 className="animate-spin" size={48} color="#12873B" style={{ margin: '0 auto 1.5rem' }} />
                <h2 style={{ fontWeight: "900" }}>Verifying...</h2>
                <p style={{ color: "#64748B", marginTop: '1rem' }}>
                    We're checking our bank feed. Once confirmed, your card will be available in your profile!
                </p>
                <button 
                    onClick={() => { window.location.href = '/partners'; }}
                    type="button"
                    style={{ ...styles.payBtn, background: '#F1F5F9', color: '#2D302D', marginTop: '2rem', width: '100%', boxShadow: 'none' }}
                >
                    Back to Partners
                </button>
            </div>
        </div>
      )}

    </div>
  );
}

function CreditCardIcon({ size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </svg>
  );
}